export const EMPTY_FIELD = 'Це поле не може бути пустим'
export const PHONE_NOT_VALID = 'Неверный номер'
